import { ObjectAction } from "./object-action.model";

export class ObjectActionWithObject {

    constructor(public action: ObjectAction, public on: any) {
    }

    async perform(): Promise<void> {
        await this.action.perform(this.on);
    }

    getTitle(): string {
        return this.action.getTitle(this.on);
    }

    getIcon(): string {
        return this.action.getIcon(this.on);
    }
}
